import { ApolloProvider } from '@apollo/client';
import { SnackbarProvider } from 'notistack';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { store, history } from 'store/index';
import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import useApolloClientAndMsalAuth from 'customHooks/useApolloClientAndMsalAuth';

import './App.css';

import AuthenticationPage from 'modules/AuthenticationPage';

import { constants } from './utils/constants';

const firebaseConfig = {
	apiKey: `${constants('FIREBASE_API_KEY')}`,
	authDomain: 'maps-geofence-portal.firebaseapp.com',
	projectId: 'maps-geofence-portal',
	storageBucket: 'maps-geofence-portal.appspot.com',
	messagingSenderId: '130503536764',
	appId: `${constants('FIREBASE_appId')}`,
	measurementId: `${constants('FIREBASE_measurementId')}`,
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const performance = getPerformance(app);

const App = () => {
	const { client } = useApolloClientAndMsalAuth();
	return (
		<ErrorBoundary>
			<ApolloProvider client={client}>
				<Provider store={store}>
					<ConnectedRouter history={history}>
						<SnackbarProvider
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'center',
							}}
							maxSnack={3}
						>
							<AuthenticationPage />
						</SnackbarProvider>
					</ConnectedRouter>
				</Provider>
			</ApolloProvider>
		</ErrorBoundary>
	);
};

export default App;
